
jQuery(document).ready ($) ->
#  submitSimpleFormWithFile '.partner-form.submitSimpleFormWithFile'
  submitSimpleForm '.submit-form'
  return

submitSimpleForm = (formSelector) ->
  formName = jQuery(formSelector).data 'form-name'
  lang = jQuery(formSelector).data 'lang'
  selector = jQuery(formSelector + ' button[type=submit]')
  jQuery(selector).unbind('click').bind 'click', (e) ->
    e.preventDefault()
    obj = jQuery(this)
    jQuery(formSelector + ' .load').remove()
    obj.hide()
    obj.parent().append('<div class="load"><img src="/wp-content/themes/cxm/static/icons/loaders/three-dots.svg" /></div>')
    jQuery('.error-input').removeClass 'error-input'
    jQuery('.error-desc').remove()


    formData = new FormData()
    formData.append 'json', createJsonFromForm(formSelector)

    fileInput = jQuery(formSelector + ' input[name="proposal"]')[0]
    if fileInput? and fileInput.files.length > 0
      formData.append 'proposal', fileInput.files[0]
#    jQuery.ajax(
#      type: 'POST'
#      url: '/wp-content/themes/cxm/forms/back/' + formName + '.php'
#      data: json: createJsonFromForm(formSelector)).done (data) ->
    jQuery.ajax(
      type: 'POST'
      url: '/wp-content/themes/cxm/forms/back/' + formName + '.php'
      data: formData
      processData: false
      contentType: false
    ).done (data) ->
        json = jQuery.parseJSON(data)
        if json['status'] == true
          if json.hasOwnProperty('remove_content')
            document.documentElement.style.overflow = ''
            jQuery('.__popup_full__').remove()
          else
            jQuery.get '/wp-content/themes/cxm/forms/messages/success.php', {token: json['token'], lang: lang}, (data) ->
              jQuery(formSelector + ' .load').remove()
              jQuery(formSelector).html data
          return
        else if json['status'] == false
          jQuery.get '/wp-content/themes/cxm/forms/messages/fail.php', {token: json['token'], lang: lang}, (data) ->
            jQuery(formSelector + ' .load').remove()
            jQuery(formSelector).html data
            return
        else
          jQuery(formSelector + ' .load').remove()
          obj.show()
          errors = jQuery.parseJSON(data)
          for error of errors
#            if jQuery('#uniform-' + error).length > 0
#              jQuery('#uniform-' + error).addClass 'error-checkbox'
#            else
            jQuery('#' + error).addClass 'error-input'
            jQuery('#' + error).parent().append('<div class="error-desc">' + errors[error] + '</div>')
        return
    return
  return

window.createJsonFromForm = (id) ->
  a = {}
  jQuery(id + ' input[type=text],  ' + id + ' input[type=number], ' + id + ' input[type=tel],  ' + id + ' input[type=date],  ' + id + ' input[type=hidden], ' + id + ' input[type=password], ' + id + ' input[type=submit], ' + id + ' textarea').each ->
    a[jQuery(this).attr('name')] = jQuery(this).val()
    return
  jQuery(id + ' select').each ->
    if jQuery(this).find('option:selected').val() == '-'
    else
      console.log 'option:selected ' +  jQuery(id + ' select').find('option:selected').val()
      console.log 'option:selected ' +  jQuery(id + ' select').find('option').val()
      a[jQuery(this).attr('name')] = jQuery(this).find('option:selected').val()
    return
  jQuery(id + ' input[type=checkbox]').each ->
    a[jQuery(this).attr('name')] = jQuery(this).is(':checked')
    return
  jQuery(id + ' input[type=radio]').each ->
    if jQuery(this).is(':checked')
      a[jQuery(this).attr('name')] = jQuery(this).val()
    return
  return JSON.stringify(a)

#submitSimpleFormWithFile = (formSelector) ->
#  selector = jQuery(formSelector + ' button[type=submit]')
#  jQuery(selector).unbind('click').bind 'click', (e) ->
#    e.preventDefault()
#    form = jQuery(this).data 'form-name'
#    lang = jQuery(this).data 'lang'
#
#    form_data = new FormData(jQuery(formSelector)[0])
#
#    obj = jQuery(this)
#    jQuery(formSelector + ' .load').remove()
#    jQuery(formSelector + ' .global-error').html()
#    obj.hide()
#    obj.parent().append('<div class="load"><img src="/wp-content/themes/cxm-io/static/icons/loaders/three-dots.svg" style="width: 75px;" /></div>')
#    jQuery('.error-input').removeClass 'error-input'
#    jQuery('.error-desc').remove()
#    jQuery.ajax(
#      type: 'POST'
#      enctype: 'multipart/form-data'
#      processData: false
#      contentType: false
#      cache: false
#      url: '/wp-content/themes/cxm-io/forms/back/' + form + '.php?lang=' + lang
#      data: json: form_data).done (data) ->
#        json = jQuery.parseJSON(data)
#        if json['status'] == true
#          jQuery.get '/wp-content/themes/cxm-io/forms/messages/success.php', {'lang': lang, 'data': json}, (data) ->
#
#            jQuery(formSelector). html data
#            return
#        else if json['status'] == false
#          jQuery.get '/wp-content/themes/cxm-io/forms/messages/fail.php', {'lang': lang, 'data': json}, (data) ->
#
#            jQuery(formSelector). html data
#            return
#        else
#          jQuery(formSelector + ' .load').remove()
#          obj.show()
#          errors = jQuery.parseJSON(data)
#          for error of errors
#            jQuery(formSelector + ' #' + error).parent().addClass 'error-input'
#            if error == 'cv'
#              jQuery(formSelector + ' #' + error).parent().append('<div class="error-desc">' + errors[error] + '</div>')
#
#        return
#      dataType: 'JSON'
#      timeout: 10000
#      false
#    return
#  return
